import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../lib/api';
import { BandWorkspace, BandToolbar, BandList } from '../components/styled/bands';

function BandsPage() {
  const { can } = useAuth();
  const navigate = useNavigate();
  const [bands, setBands] = useState([]);
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    api.getBands().then((data) => { if (active) setBands(data.bands); })
      .catch((failure) => { if (active) setError(failure.message); })
      .finally(() => { if (active) setBusy(false); });
    return () => { active = false; };
  }, []);
  const create = async (event) => {
    event.preventDefault(); setBusy(true); setError('');
    try { const data = await api.createBand(name.trim()); navigate(`/bands/${data.band._id}`); }
    catch (failure) { setError(failure.message); }
    finally { setBusy(false); }
  };
  return (
    <BandWorkspace>
      <h1>Bands</h1>
      {can('bands:manage') ? <BandToolbar><form onSubmit={create}>
        <label>Band name<input required maxLength={120} value={name} onChange={(event) => setName(event.target.value)} disabled={busy} /></label>
        <button disabled={busy || !name.trim()} type="submit">Create Band</button>
      </form></BandToolbar> : null}
      {error ? <p className="error" role="alert">{error}</p> : null}
      {busy ? <p role="status">Loading...</p> : <BandList>{bands.map((band) => <li key={band._id}>
        <div className="details"><Link to={`/bands/${band._id}`}>{band.name}</Link>
          <p className="muted">{band.memberCount} {band.memberCount === 1 ? 'member' : 'members'}</p></div>
        <span>{band.canManage ? 'Manager access' : 'Member access'}</span>
      </li>)}</BandList>}
      {!busy && !error && !bands.length ? <p>No bands yet.</p> : null}
    </BandWorkspace>
  );
}

export default BandsPage;
